export const FALLBACK_IMG =
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'><rect width='400' height='300' fill='#E2E8F0'/><g transform='translate(170,110)'><rect x='0' y='0' width='60' height='48' rx='6' fill='none' stroke='#94A3B8' stroke-width='4'/><circle cx='18' cy='16' r='6' fill='#94A3B8'/><path d='M6 40 L22 26 L34 36 L44 24 L54 40 Z' fill='#94A3B8'/></g><text x='200' y='195' text-anchor='middle' font-family='sans-serif' font-size='14' fill='#94A3B8'>Imagen no disponible</text></svg>`
  );

export const handleImgError = (e) => {
  if (e.target.dataset.fallbackApplied) return;
  e.target.dataset.fallbackApplied = "1";
  e.target.src = FALLBACK_IMG;
};
